import COUNTRIES from '../countries.translations'

import translations from './rare-earth.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/ree'

export const rareEarth: Metal = {
  id: 10,
  slug: 'ree',
  name: t.name,
  symbol: 'REE',
  // The sheet's six pins, named by place as it names them: Baotou rather than the Bayan
  // Obo deposit 150km north that the copy discusses, Laverton rather than Mount Weld,
  // Ganzhou and Longnan as two separate Jiangxi pins, Myitkyina rather than Kachin State
  // as a whole. No operators — the sheet names none. The order is the sheet's, which
  // happens to run light REEs first, then the heavy ion-adsorption clay deposits.
  mines: [
    {
      name: 'Baotou (China)',
      region: t.mine0Region,
      slug: 'baotou',
      coordinates: [109.84, 40.66],
    },
    {
      name: 'Mountain Pass (USA)',
      region: t.mine1Region,
      slug: 'mountain-pass',
      coordinates: [-115.53, 35.48],
    },
    {
      name: 'Laverton (Australia)',
      region: t.mine2Region,
      slug: 'laverton',
      coordinates: [122.4, -28.63],
    },
    {
      name: 'Ganzhou (China)',
      region: t.mine3Region,
      slug: 'ganzhou',
      coordinates: [114.93, 25.85],
    },
    {
      name: 'Longnan (China)',
      region: t.mine4Region,
      slug: 'longnan',
      coordinates: [114.79, 24.91],
    },
    {
      name: 'Myitkyina (Myanmar)',
      region: t.mine5Region,
      slug: 'myitkyina',
      coordinates: [97.4, 25.38],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 69.2 },
    { name: COUNTRIES.unitedStates, percent: 11.5 },
    { name: COUNTRIES.myanmar, percent: 7.9 },
    { name: COUNTRIES.australia, percent: 3.3 },
    { name: COUNTRIES.nigeria, percent: 3.3 },
  ],
  important: true,
  // No `related`: the sheet's Related Metal row is blank — see the note in the handover.
  video: {
    name: 'rare-earth',
    poster: '/mine-my-phone/images/posters/rare-earth.jpg',
  },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['screen', 'camera', 'electronics', 'casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 3, ...t.impacts.environmental },
      human: { severity: 3, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
          credit: 'Bloomberg / Getty',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
        },
      ],
      secondBento: [
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
          credit: 'Michel Lunanga / Getty',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/07.jpg`,
          orientation: 'vertical',
          credit: 'Pes-Anders Pettersson / Getty',
        },
      ],
    },
  },
}
